import {
    createContext,
} from "react";

export const CreateFileContext = createContext({rerenderFileInfo: () => {}});
